import stylesheet_10 from '../stylesheets/10.js';
import stylesheet_17 from '../stylesheets/17.js';
import stylesheet_16 from '../stylesheets/16.js';
import stylesheet_18 from '../stylesheets/18.js';
import stylesheet_15 from '../stylesheets/15.js';
import stylesheet_13 from '../stylesheets/13.js';
import stylesheet_11 from '../stylesheets/11.js';

export const index = 14;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/services/international-students/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/14.d9c4ac10.js","_app/immutable/chunks/scheduler.2887eafe.js","_app/immutable/chunks/index.387b3ba3.js","_app/immutable/chunks/Wrapper.6637e6f2.js","_app/immutable/chunks/Hero.8f39fbbd.js","_app/immutable/chunks/each.77017db3.js","_app/immutable/chunks/ContentCard.cca2716c.js","_app/immutable/chunks/Roadmap.8b006e20.js","_app/immutable/chunks/Image.bc01061b.js","_app/immutable/chunks/Button.4c366cb7.js","_app/immutable/chunks/BookOpenPageVariant.a71a627f.js","_app/immutable/chunks/CastEducation.f00318ac.js","_app/immutable/chunks/Turbine.b389d3b5.js"];
export const stylesheets = ["_app/immutable/assets/14.7ea1ae3f.css","_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Hero.71a30b75.css","_app/immutable/assets/ContentCard.b5a2f49f.css","_app/immutable/assets/Roadmap.0ad4251b.css","_app/immutable/assets/Image.1c236230.css","_app/immutable/assets/Button.4c43b995.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/14.7ea1ae3f.css": stylesheet_10,
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_17,
	"_app/immutable/assets/Hero.71a30b75.css": stylesheet_16,
	"_app/immutable/assets/ContentCard.b5a2f49f.css": stylesheet_18,
	"_app/immutable/assets/Roadmap.0ad4251b.css": stylesheet_15,
	"_app/immutable/assets/Image.1c236230.css": stylesheet_13,
	"_app/immutable/assets/Button.4c43b995.css": stylesheet_11
});
